<div class="modal-header" translate>Render sequence</div>
<form class="modal-body" #form="ngForm">
  <div class="form-line">
    <div class="header">
      <div class="title" translate>Name</div>
    </div>
    <input
      class="form-control"
      type="text"
      [(ngModel)]="name"
      name="name"
      required
      maxlength="250"
    />
  </div>
  <div class="form-line">
    <div class="header">
      <div class="title" translate>Preset</div>
    </div>
    <div class="input-group">
      <select class="form-control" [(ngModel)]="presetName" name="presetName" required>
        @for (p of presets; track p) {
          <option [ngValue]="p">{{ p }}</option>
        }
      </select>
    </div>
  </div>
</form>
<div class="modal-footer">
  <button class="btn btn-outline-primary" [clickBlocking]="render" [disabled]="!form.form.valid">
    <i class="far fa-play"></i>
    <span translate>Render</span>
  </button>
  <button class="btn btn-outline-secondary" (click)="cancel()" translate>Cancel</button>
</div>
